import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "avatar-bar"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "apostle-empty"
};
const _hoisted_4 = {
  key: 2,
  class: "divider"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "nickname"
};
import { ref, computed } from 'vue';
import { placeholderImage } from '@/tools/utils'; // pre-declaration

export default {
  __name: 'StageRolesBar',
  props: {
    roles: {
      type: Array,
      required: true,
      default: () => []
    },
    capacity: {
      type: Number,
      default: 6
    },
    apostle: {
      type: Object,
      required: false,
      default: () => null
    },
    onlineRoles: {
      type: Array,
      required: false,
      default: () => []
    },
    itemDiameter: {
      type: Number,
      required: true
    }
  },

  setup(__props) {
    _useCssVars(_ctx => ({
      "v45f451a3": __props.itemDiameter + 'px'
    }));

    const props = __props; // refs

    const avatarStyle = ref({
      width: `${props.itemDiameter}px`,
      height: `${props.itemDiameter}px`
    }); // computed

    const dataArray = computed(() => {
      let buffer = [];

      for (let i = 0; i < props.capacity; i++) {
        // const dataIndex = props.capacity - 1 - i
        if (i >= props.roles.length) {
          buffer.push({
            'nickname': '',
            'avatar': placeholderImage,
            'isOnline': false
          });
        } else {
          const roleData = props.roles[i];
          buffer.push({ ...roleData,
            'isOnline': props.onlineRoles.includes(roleData.id)
          });
        }
      }

      return buffer;
    }); // functions
    // const getNicknameStyle = (index) => {
    //   const count = props.showNumber
    //   if (count === 0) return {}
    //
    //   const centerX = props.itemDiameter / 2
    //   const centerY = props.itemDiameter / 2
    //   const radius = props.itemDiameter / 2 + 15
    //
    //   const angle = (360 / count) * index - 90
    //   const radian = (angle * Math.PI) / 180
    //
    //   const nicknameCenterX = centerX + (radius) * Math.cos(radian)
    //   const nicknameCenterY = centerY + (radius) * Math.sin(radian)
    //
    //   // console.log(`nickname = ${angle}`)
    //   let transform = 'translate(-50%, -50%)';
    //   if (Math.abs(angle) < 89) {
    //     // console.log(`${index}右`)
    //     transform = 'translate(0%, -50%)';
    //   } else if (Math.abs(angle) > 91) {
    //     // console.log(`${index}左`)
    //     transform = 'translate(-100%, -50%)';
    //   } else {
    //     // console.log(`${index}中`)
    //   }
    //
    //   return {
    //     left: `${nicknameCenterX}px`,
    //     top: `${nicknameCenterY}px`,
    //     transform: transform,
    //     whiteSpace: 'nowrap',
    //   }
    // }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.apostle ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["avatar-item apostle", __props.apostle?.is_online ? 'online' : 'offline']),
        style: _normalizeStyle(avatarStyle.value)
      }, [_createElementVNode("img", {
        src: __props.apostle?.avatar ?? _unref(placeholderImage),
        alt: "",
        draggable: "false"
      }, null, 8, _hoisted_2)], 6)) : (_openBlock(), _createElementBlock("div", _hoisted_3)), __props.apostle ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["avatar-item", item.isOnline ? 'online' : 'offline']),
          style: _normalizeStyle(avatarStyle.value)
        }, [_createElementVNode("img", {
          src: item.avatar,
          alt: "",
          draggable: "false"
        }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(item.nickname), 1)], 6);
      }), 128))]);
    };
  }

};